const Error = () => {
    return (
        <h1 style={{ color: 'white', marginTop: '33%', fontStyle: 'bolder' }}>
            :O Oops, we ran into some trouble!
        </h1>
    )
}
export default Error